module.exports = __webpack_public_path__ + "img/tech-logo.1e27dcef.jpg";